import { ParseColour } from './ReportColourParser';
import autoTable from 'jspdf-autotable';

const writeTableToBody = (config, reportPdf, rows) => {
    if (rows.length > 0) {
        let columns = 0;

        const body = [];
        for (const row of rows) {
            const newRow = row.split('|');
            body.push(newRow);
            columns = newRow.length;
        }

        const colWidths = config.Width
            ? config.Width.split('|').map(Number)
            : [];
        const totalWidth = colWidths.reduce(
            (accumulator, width) => accumulator + width,
            0
        );
        while (colWidths.length < columns) colWidths.push(0);

        const columnStyles = colWidths.map((c) => {
            return { cellWidth: parseInt(c) };
        });

        const startY =
            reportPdf.getCurrentLinePosition() +
            (config.Head ? reportPdf.spacing.md : reportPdf.spacing.sm);

        const autoTableConfig = {
            head: config.Head && [config.Head],
            startY: startY,
            margin: {
                left: config.Left,
                bottom: reportPdf.getFooterHeight() + 10, // TODO: use reportPdf content margin not 10
                right: config.Right,
                top: reportPdf.getHeaderHeight() + 10, // TODO: use reportPdf content margin not 10
            },
            body: body,
            didDrawCell: (data) => {
                reportPdf.setCurrentLinePosition(
                    data.cursor.y + data.row.height + 3
                );
            },
            columnStyles: {
                columnStyles,
            },
            tableWidth:
                totalWidth ||
                reportPdf.internal.pageSize.width -
                    (reportPdf.getMargins().left +
                        reportPdf.getMargins().right),
            ...(config.Colour && {
                headStyles: {
                    fillColor: ParseColour(config.Colour),
                },
            }),
        };

        autoTable(reportPdf, autoTableConfig)
    }
};

export { writeTableToBody as WriteTableToBody };
